module.exports = __webpack_public_path__ + "media/tph/bghead-d73b0cd4.png";